const enum ReportDataType {
  ATTENDEE_LIST = 'attendee-list',
  CAMPAIGN_OVERVIEW = 'campaign-overview',
  CANCELLATIONS_OVER_TIME = 'cancellations-over-time',
  CLOSED_OPPORTUNTIES = 'closed-opportunities',
  CLOSED_OPPORTUNITIES_BY_OWNER = 'closed-opportunities-by-owner',
  CURRENT_STATE_DASHBOARD = 'current-state-dashboard',
  DEDICATIONS = 'dedications',
  DEDICATIONS_LIST = 'dedications-list',
  DEDICATIONS_SUMMARY = 'dedications-list-summary',
  DONATIONS = 'donation-list-view',
  DONATIONS_LIST = 'donation-list',
  DONATIONS_SUMMARY = 'donation-list-view-summary',
  DONATIONS_BY_CAMPAIGN = 'donations-by-campaign',
  DONATIONS_BY_CATEGORY = 'donations-by-category',
  DONATIONS_BY_TYPE = 'donations-by-type',
  DONATIONS_OVER_TIME = 'donations-over-time',
  DONATION_SUMMARY = 'donation-summary',
  DONOR_LIST = 'donor-list',
  GRANTS = 'grants',
  LYBUNT = 'lybunt',
  LYBUNT_LIST = 'lybunt-list',
  LYBUNT_SUMMARY = 'lybunt-summary',
  NEW_DONOR_GROWTH = 'new-donor-growth',
  NEW_DONOR_GROWTH_SUMMARY = 'donor-summary',
  ONE_TIME_VS_RECURRING_DONATIONS = 'one-time-vs-recurring-donations',
  OPPORTUNITIES = 'opportunities',
  OPPORTUNITIES_BY_CONFIDENCE_LEVEL = 'opportunities-by-confidence-level',
  OPPORTUNITIES_BY_STAGE = 'opportunities-by-stage',
  OPPORTUNITIES_COMPARISON = 'opportunities-values-comparison',
  OPPORTUNITIES_LOST_BY_OWNER = 'lost-by-owner',
  OPPORTUNITIES_WON_BY_OWNER = 'won-by-owner',
  PLEDGES = 'pledges',
  PLEDGE_BREAKDOWN = 'pledge-breakdown',
  PLEDGE_LIST = 'pledge-list',
  PLEDGE_SUMMARY = 'pledge-summary',
  RECURRING_DONATIONS = 'recurring-payments',
  RECURRING_DONATIONS_SUMMARY = 'recurring-payments-summary',
  RECURRING_DONATIONS_SOURCE = 'plan-source',
  RECURRING_DONATIONS_BREAKDOWN = 'recurring-breakdown',
  RECURRING_INCOME_OVER_TIME = 'recurring-income-over-time',
  RECURRING_INCOME_OVER_TIME_FORECAST = 'recurring-income-forecast',
  SYBUNT = 'sybunt',
  SYBUNT_LIST = 'sybunt-list',
  SYBUNT_SUMMARY = 'sybunt-summary',
  TEAM_MEMBERS = 'team-members',
  TICKET_SUMMARY = 'ticket-summary',
}

export default ReportDataType;
